import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, Suspense } from 'react';
import { FlagGroup } from '@atlaskit/flag';
import { getProductReleaseVersion } from '@atlassian/search-common';
import { useIntl } from 'react-intl-next';
import { useUserContext } from '../../common/user-context';
import { FeedbackButton } from '../../common/feedback-collector/feedback-button';
import { BUILD_VERSION } from '../../buildVersion';
import { useTypedAggregatorClient } from '../aggregator-client-context';
import { useProductContext } from '../product-router';
import { useFeaturesContext } from '../features-context/features-context';
import { useExperiments } from '../../common/experiment-provider';
var AkFeedbackCollector = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/feedback-collector" */'@atlaskit/feedback-collector').then(function (module) {
    return {
      default: module.default
    };
  });
});
var AkFeedbackFlag = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/product-search-dialog/feedback-flag" */'@atlaskit/feedback-collector').then(function (_ref) {
    var FeedbackFlag = _ref.FeedbackFlag;
    return {
      default: FeedbackFlag
    };
  });
});
var HELLO_TENANT_ID = 'a436116f-02ce-4520-8fbb-7301462a1674';
var ENTRYPOINT_ID = '9b88e53b-d04d-4f1c-ae85-6d7f59d1ca7a';
var FEEDBACK_CONTEXT_CF = 'customfield_10047';

/**
 * Feedback collector for extensible tabs in Quick Search i.e. confluence tab in QS and QF
 */
var FeedbackCollector = function FeedbackCollector(_ref2) {
  var _getActiveProduct, _getPrimaryProduct, _useFeaturesContext$q;
  var _ref2$TriggerComponen = _ref2.TriggerComponent,
    TriggerComponent = _ref2$TriggerComponen === void 0 ? FeedbackButton : _ref2$TriggerComponen;
  var _useUserContext = useUserContext(),
    user = _useUserContext.user;
  var name = user.name,
    id = user.id;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    displayFlag = _useState4[0],
    setDisplayFlag = _useState4[1];
  var aggregatorClient = useTypedAggregatorClient();
  var cloudId = aggregatorClient.getAggregatorConfig().cloudId;
  var _useExperiments = useExperiments(),
    backendExperiment = _useExperiments.backendExperiment,
    _useExperiments$front = _useExperiments.frontendExperiments,
    frontendExperiments = _useExperiments$front === void 0 ? {} : _useExperiments$front;
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct,
    getPrimaryProduct = _useProductContext.getPrimaryProduct;
  var activeProduct = (_getActiveProduct = getActiveProduct()) === null || _getActiveProduct === void 0 ? void 0 : _getActiveProduct.title;
  var primaryProduct = (_getPrimaryProduct = getPrimaryProduct()) === null || _getPrimaryProduct === void 0 ? void 0 : _getPrimaryProduct.title;
  var isHello = HELLO_TENANT_ID === cloudId;
  var isQuickFind = (_useFeaturesContext$q = useFeaturesContext().quickFind) === null || _useFeaturesContext$q === void 0 ? void 0 : _useFeaturesContext$q.enabled;
  var experience = isQuickFind ? 'quick-find' : 'quick-search';
  var feedbackContext = JSON.stringify({
    experimentLayers: backendExperiment === null || backendExperiment === void 0 ? void 0 : backendExperiment.experimentLayers,
    frontendExperiments: frontendExperiments,
    frontendVersion: BUILD_VERSION,
    product: activeProduct,
    primaryProduct: primaryProduct,
    cloudId: cloudId,
    userId: id,
    source: 'product-search-dialog',
    isHello: isHello,
    experience: experience,
    release: getProductReleaseVersion(primaryProduct)
  });
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TriggerComponent, {
    onClick: function onClick(e) {
      e.preventDefault();
      setIsOpen(true);
    }
  }), isOpen ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(AkFeedbackCollector, {
    locale: locale,
    onClose: function onClose() {
      return setIsOpen(false);
    },
    onSubmit: function onSubmit() {
      return setDisplayFlag(true);
    },
    atlassianAccountId: id,
    name: name,
    entrypointId: ENTRYPOINT_ID,
    additionalFields: [{
      id: FEEDBACK_CONTEXT_CF,
      value: feedbackContext
    }]
  })) : null, displayFlag && /*#__PURE__*/React.createElement(FlagGroup, {
    onDismissed: function onDismissed() {
      return setDisplayFlag(false);
    }
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(React.Fragment, null)
  }, /*#__PURE__*/React.createElement(AkFeedbackFlag, {
    locale: locale
  }))));
};
export default FeedbackCollector;